import { h } from 'preact';
import { SliderRightIcon } from '../Icons';

import './style.scss';

type Props = {
  title: string;
  description: string;
  onPress?: () => void;
};

function ResolveOption({ title, description, onPress }: Props) {
  return (
    <div className="resolve-option_ta" onClick={onPress}>
      <div className="leading_ta">
        <h3>{title}</h3>
        <div className="description_ta">{description}</div>
      </div>
      <div className="trailing_ta">
        <SliderRightIcon size={10} />
      </div>
    </div>
  );
}
export default ResolveOption;
